import React from "react";
import {
  Box,
  Heading,
  List,
  ListItem,
  ListIcon,
  Text,
  VStack,
  HStack,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiCheckCircle, FiList, FiTarget, FiFileText } from "react-icons/fi";

/**
 * @param {{ summaryStructured?: { summary?: string, keyPoints?: string[], actionItems?: string[] }, summary?: string }} props
 */
export default function ScreenListenSummaryView({
  summaryStructured,
  summary = "",
}) {
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const muted = useColorModeValue("gray.600", "gray.400");
  const summaryBg = useColorModeValue("teal.50", "teal.900");
  const pointsBg = useColorModeValue("blue.50", "blue.900");
  const actionsBg = useColorModeValue("orange.50", "orange.900");
  const summaryTextColor = useColorModeValue("gray.800", "gray.100");

  const s = summaryStructured || {};
  const summaryText = (s.summary || summary || "").trim();
  const keyPoints = Array.isArray(s.keyPoints) ? s.keyPoints : [];
  const actionItems = Array.isArray(s.actionItems) ? s.actionItems : [];

  if (!summaryText && !keyPoints.length && !actionItems.length) {
    return (
      <Text fontSize="sm" color={muted}>
        No summary yet.
      </Text>
    );
  }

  return (
    <VStack align="stretch" spacing={4}>
      {summaryText ? (
        <Box
          p={5}
          borderRadius="xl"
          bg={summaryBg}
          borderWidth="1px"
          borderColor={borderColor}
        >
          <HStack mb={3} spacing={2}>
            <Icon as={FiFileText} color="teal.500" />
            <Heading size="sm" fontWeight="semibold">
              Summary
            </Heading>
          </HStack>
          <Text fontSize="md" lineHeight="tall" color={summaryTextColor}>
            {summaryText}
          </Text>
        </Box>
      ) : null}

      {keyPoints.length > 0 ? (
        <Box
          p={5}
          borderRadius="xl"
          bg={pointsBg}
          borderWidth="1px"
          borderColor={borderColor}
        >
          <HStack mb={3} spacing={2}>
            <Icon as={FiList} color="blue.500" />
            <Heading size="sm" fontWeight="semibold">
              Key points
            </Heading>
          </HStack>
          <List spacing={2}>
            {keyPoints.map((point, i) => (
              <ListItem key={i} fontSize="sm" lineHeight="tall">
                <ListIcon as={FiCheckCircle} color="blue.400" />
                {point}
              </ListItem>
            ))}
          </List>
        </Box>
      ) : null}

      {actionItems.length > 0 ? (
        <Box
          p={5}
          borderRadius="xl"
          bg={actionsBg}
          borderWidth="1px"
          borderColor={borderColor}
        >
          <HStack mb={3} spacing={2}>
            <Icon as={FiTarget} color="orange.500" />
            <Heading size="sm" fontWeight="semibold">
              Action items
            </Heading>
          </HStack>
          <List spacing={2}>
            {actionItems.map((item, i) => (
              <ListItem key={i} fontSize="sm" lineHeight="tall">
                <ListIcon as={FiCheckCircle} color="orange.400" />
                {item}
              </ListItem>
            ))}
          </List>
        </Box>
      ) : null}
    </VStack>
  );
}
